export { default } from "Explore/Components/SocialImpact/SocialImpactCard";
